import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/menu_icons/Editare_profil.png'


const _withScopeId = n => (_pushScopeId("data-v-233839c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-lg ecran-container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_3 = {
  key: 0,
  class: "app__page__title__container"
}
const _hoisted_4 = {
  class: "app__page__title",
  style: {"white-space":"nowrap"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"position":"relative","width":"24px","height":"24px"}
}, null, -1))
const _hoisted_6 = { style: {"margin":"auto"} }
const _hoisted_7 = { style: {"margin-left":"auto"} }
const _hoisted_8 = {
  key: 0,
  class: "dashboard__document__section app__border__bottom"
}
const _hoisted_9 = { class: "dashboard__product__details" }
const _hoisted_10 = { class: "app__label--small" }
const _hoisted_11 = { class: "app__label--small" }
const _hoisted_12 = { class: "app__label--small" }
const _hoisted_13 = { class: "app__label--small" }
const _hoisted_14 = { class: "app__label--small" }
const _hoisted_15 = { class: "app__label--small" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard__document__icons" }, null, -1))
const _hoisted_17 = { class: "dashboard__product__details" }
const _hoisted_18 = {
  key: 0,
  class: "app__label--small",
  style: {"font-weight":"bold"}
}
const _hoisted_19 = { class: "app__color--label" }
const _hoisted_20 = {
  key: 1,
  class: "app__label--small",
  style: {"font-weight":"bold"}
}
const _hoisted_21 = { class: "app__color--label" }
const _hoisted_22 = {
  key: 2,
  class: "app__label--small",
  style: {"font-weight":"bold"}
}
const _hoisted_23 = { class: "app__property--small" }
const _hoisted_24 = {
  key: 3,
  class: "app__label--small",
  style: {"font-weight":"bold"}
}
const _hoisted_25 = {
  class: "app__color--semigray",
  style: {"font-weight":"lighter"}
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { key: 4 }
const _hoisted_31 = { key: 5 }
const _hoisted_32 = { key: 6 }
const _hoisted_33 = { key: 7 }
const _hoisted_34 = {
  key: 4,
  class: "app__label--small",
  style: {"font-weight":"bold"}
}
const _hoisted_35 = { style: {"display":"flex","flex-direction":"column","justify-content":"flex-start"} }
const _hoisted_36 = { class: "app__property--small" }
const _hoisted_37 = { class: "app__property--small" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_40 = { class: "dashboard__document__icons" }
const _hoisted_41 = { class: "q-pa-lg flex flex-center" }
const _hoisted_42 = {
  key: 0,
  class: "app__title--small",
  style: {"position":"absolute","left":"50%","margin-left":"-100px"}
}
const _hoisted_43 = {
  key: 1,
  class: "app__back__bar--title",
  style: {"position":"absolute","left":"calc(50% - 100px)","top":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_EditArticle = _resolveComponent("EditArticle")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.manage_items')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_q_btn, {
          "no-caps": "",
          style: {"background-color":"#9b7d32","color":"white"},
          onClick: _ctx.syncronizeApollo,
          loading: _ctx.loadingApollo
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('message.manage_items_apollo')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_q_input, {
          "bottom-slots": "",
          debounce: "300",
          modelValue: _ctx.filterText,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterText) = $event)),
          dense: ""
        }, {
          append: _withCtx(() => [
            (_ctx.filterText !== '')
              ? (_openBlock(), _createBlock(_component_q_icon, {
                  key: 0,
                  name: "close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterText = '')),
                  class: "cursor-pointer"
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_q_icon, { name: "search" })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _withDirectives(_createVNode(_component_q_btn, {
        square: "",
        style: {"background-color":"#9b7d32","color":"white"},
        icon: "add",
        class: "article--add--btn",
        onClick: _ctx.onOpenFormAddNewArticle
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tooltip, {
            "transition-show": "scale",
            "transition-hide": "scale"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('message.add_new_item')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"]), [
        [_vShow, 1==2]
      ])
    ]),
    (_ctx.$q.platform.is.desktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('message.item_code')), 1),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('message.name2')), 1),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('message.category')), 1),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('message.features')), 1),
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('message.measure_units')), 1),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('message.client_visible')), 1)
          ]),
          _hoisted_16
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrArticles, (article) => {
      return (_openBlock(), _createElementBlock("div", {
        key: article.appid,
        class: "dashboard__document__section app__border__bottom"
      }, [
        _createElementVNode("div", _hoisted_17, [
          (_ctx.$q.platform.is.mobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('message.item_code')) + ":", 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_19, _toDisplayString(article.code), 1),
          (_ctx.$q.platform.is.mobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t('message.name2')) + ":", 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$i18n.locale == 'de' ? article.name_de : _ctx.$i18n.locale == 'ro' ? article.name_ro : _ctx.$i18n.locale == 'en' ? article.name_en : article.name_hu), 1),
          (_ctx.$q.platform.is.mobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('message.category')) + ":", 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$i18n.locale == 'de' ? article.lantHierarchyCategoriesDe : _ctx.$i18n.locale == 'ro' ? article.lantHierarchyCategoriesRo : _ctx.$i18n.locale == 'en' ? article.lantHierarchyCategoriesEn : article.lantHierarchyCategoriesHu), 1),
          (_ctx.$q.platform.is.mobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('message.features')) + ":", 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_25, [
            (article.sizeLength)
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('message.length')) + " " + _toDisplayString(article.sizeLength) + " " + _toDisplayString(article.UMBase == 'M' ? 'M ' : 'mm '), 1))
              : _createCommentVNode("", true),
            (article.sizeWidth)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('message.width')) + " " + _toDisplayString(article.sizeWidth) + " mm ", 1))
              : _createCommentVNode("", true),
            (article.sizeThickness)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('message.thickness')) + " " + _toDisplayString(article.sizeThickness) + " mm ", 1))
              : _createCommentVNode("", true),
            (article.sizeDiameter)
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('message.diameter')) + " " + _toDisplayString(article.sizeDiameter) + " mm ", 1))
              : _createCommentVNode("", true),
            (article.sizeHeight)
              ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t('message.height')) + " " + _toDisplayString(article.sizeHeight) + " mm ", 1))
              : _createCommentVNode("", true),
            (article.sizeAlloy)
              ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.$t('message.aliaj')) + " " + _toDisplayString(article.sizeAlloy) + "  ", 1))
              : _createCommentVNode("", true),
            (article.sizeEyes)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.$t('message.eyes')) + " " + _toDisplayString(article.sizeEyes) + " mm ", 1))
              : _createCommentVNode("", true),
            (article.sizeEyes2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t('message.eyes')) + " 2 " + _toDisplayString(article.sizeEyes2) + " mm", 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.$q.platform.is.mobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.$t('message.measure_units')) + ":", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("span", _hoisted_36, _toDisplayString(article.UMBase), 1),
            _createElementVNode("span", _hoisted_37, [
              _createTextVNode(_toDisplayString(article.um2) + " ", 1),
              (article.um2 && article.um2.length>0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_38, "(" + _toDisplayString(article.um1ToUm2) + ")", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_q_checkbox, {
              modelValue: article.isActive,
              "onUpdate:modelValue": [($event: any) => ((article.isActive) = $event), ($event: any) => (_ctx.changeStatus(article))],
              label: _ctx.$q.platform.is.mobile? _ctx.$t('message.visible') :'',
              "true-value": "y",
              "false-value": "n"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
            (_ctx.$q.platform.is.mobile)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  color: "#273233",
                  icon: "edit",
                  label: "Edit",
                  onClick: ($event: any) => (_ctx.openProductForEditing(article)),
                  size: "xs",
                  style: {"max-height":"1rem","margin-left":"2rem"}
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          (_ctx.$q.platform.is.desktop)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 0,
                name: "edit",
                style: {"color":"#F7C325","font-size":"1.5rem","cursor":"pointer","margin-left":"16px"},
                onClick: ($event: any) => (_ctx.openProductForEditing(article))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tooltip, {
                    "transition-show": "scale",
                    "transition-hide": "scale",
                    anchor: "center left",
                    self: "center right",
                    offset: [10, 10]
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.edit_item')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (1==2)
            ? (_openBlock(), _createBlock(_component_q_icon, {
                key: 1,
                name: "delete_forever",
                style: {"color":"red","font-size":"1.5rem","cursor":"pointer"}
              }))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_41, [
      _createVNode(_component_q_pagination, {
        modelValue: _ctx.currentPageNumber,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentPageNumber) = $event)),
        max: _ctx.maxPagesNumber,
        input: "",
        onInput: _ctx.inputPaginator
      }, null, 8, ["modelValue", "max", "onInput"])
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.isShoDialogEditArticle,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isShoDialogEditArticle) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": _ctx.dialogTransitionShow,
      "transition-hide": _ctx.dialogTransitionHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, { style: {"min-height":"40px"} }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_icon, {
                  name: "arrow_back_ios",
                  class: "app__arrow--back",
                  color: "black",
                  style: {"cursor":"pointer"}
                }, null, 512), [
                  [_directive_close_popup]
                ]),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.$t('message.edit_item')), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, "edit_item"))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createBlock(_component_q_space, {
                      key: 2,
                      dense: ""
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_scroll_area, { style: {"height":"85vh"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_EditArticle, {
                      pid: _ctx.selectedPidArticle,
                      product_code: _ctx.selectedProductCode,
                      closeHandler: _ctx.closeFormEditArticle
                    }, null, 8, ["pid", "product_code", "closeHandler"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "transition-show", "transition-hide"])
  ]))
}